import Button from 'components/button';
import { Title } from 'components/commons';
import Modal from 'components/commons/modal';
import React, { useEffect, useState } from 'react';
import bizContaTitle from 'assets/svg/biz-conta-title.svg';
import arrowIcon from 'assets/svg/arrows.svg';
import dolarIcon from 'assets/img/dolar.png';
import touchIcon from 'assets/svg/touch.svg';
import './modal-bizconta.scss';

type ModalBizcontaProps = {
    openModal: boolean,
};


const ModalBizconta: React.FC<ModalBizcontaProps> = ({ openModal }) => {
    const [modalVisibility, setModalVisibility] = useState(false);
    useEffect(() => {
        setModalVisibility(openModal)
    }, [openModal]);

    return (
        <>
            <Modal
                title=""
                fitMobileScreen={false}
                visible={modalVisibility}
                onClose={() => setModalVisibility(false)}
                className="l-feedeback__modal"
            >
                <div className="l-feedeback__modal-content ">
                    <img src={bizContaTitle} />
                    <Title>
                        Preparamos uma <br />
                            surpresa pra você!
                        </Title>

                    <p className="text">
                        Já imaginou uma conta com:
                    </p>
                    <div className="l-feedeback__modal-content__bizconta ">
                        <ul>
                            <li> <div><img className="icon-arrows" src={arrowIcon} /></div>TED e Pix grátis</li>
                            <li> <div><img className="icon-dolar" src={dolarIcon} /></div>Sem mensalidade</li>
                            <li> <div><img className="icon-touch" src={touchIcon} /></div>Fácil e simples de usar</li>
                        </ul>
                    </div>
                    <a href="https://biz-conta.onelink.me/7nkz?pid=site&c=modal&af_adset=tela-desist%C3%AAncia" target="_blank"><Button label="quero saber mais" /></a>
                </div>
            </Modal>
        </>
    );
};

export default ModalBizconta;
